import React from 'react';
import Layout from '../common/components/Layout';

const Settings = () => {
  // Sample data for tables
  const branchData = [
    { id: 1, name: 'Head Office', code: 'HO01' },
    { id: 2, name: 'Branch 1', code: 'B001' },
  ];

  const userData = [
    { id: 1, username: 'jdoe', email: 'jdoe@example.com' },
    { id: 2, username: 'asmith', email: 'asmith@example.com' },
  ];

  const jobData = [
    { id: 1, title: 'Software Engineer', type: 'Full-time' },
    { id: 2, title: 'Accountant', type: 'Part-time' },
  ];

  const departmentData = [
    { id: 1, name: 'HR', manager: 'John Doe' },
    { id: 2, name: 'Finance', manager: 'Jane Smith' },
  ];

  // Table rendering helper
  const renderTable = (columns, data, sectionName) => (
    <div className="card mb-4 shadow-sm p-3 bg-white">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>{sectionName}</h4>
        <button className="btn btn-success">Create</button>
      </div>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead className="table-light">
            <tr>
              {columns.map((col) => (
                <th key={col}>{col}</th>
              ))}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.id}>
                {columns.map((col) => (
                  <td key={col}>{row[col.toLowerCase()]}</td>
                ))}
                <td>
                  <button className="btn btn-primary btn-sm me-2">Update</button>
                  <button className="btn btn-danger btn-sm">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <Layout>
      <div className="container mt-4 p-4">
        <h2 className="mb-4">Employee Settings</h2>

        {renderTable(['Name', 'Code'], branchData, 'Branch')}
        {renderTable(['Username', 'Email'], userData, 'User')}
        {renderTable(['Title', 'Type'], jobData, 'Job Title')}
        {renderTable(['Name', 'Manager'], departmentData, 'Department')}
      </div>
    </Layout>
  );
};

export default Settings;
